import { ApiFileCabinetDataSource, createFileCabinetProviderClients, FileCabinetStore, ProviderDisplayDocumentType } from '@enter/core';
import { RootStore } from 'stores';
import { ProviderDemoFileCabinetDataSource } from './file-cabinet.demo-source';

/** The fetch group the File Cabinet's requests run in. */
export const FILE_CABINET_FETCH_GROUP = 'file-cabinet';

/**
 * The provider app's File Cabinet store (FE-225), on the `/provider/…` lists.
 *
 * `setGroup` puts each request in a group that skips the app's global error dialog: the screen says
 * what failed itself — a banner for the list, "No access" or `—` for a count — and a dialog per
 * failed count would bury it. The group is global, so the page resets it when it closes.
 *
 * In demo mode nothing may reach the API or render real data (NS-14): the generated source is used
 * instead — the same generators the Documents, Mail and Fax pages use in demo. Demo mode switches with
 * a reload, so it is settled by the time the page builds its store.
 */
export function createProviderFileCabinetStore(rootStore: RootStore, setGroup: () => void): FileCabinetStore {
    const dataSource = rootStore.isDemo()
        ? new ProviderDemoFileCabinetDataSource(
              rootStore.demoGenerators.proxy('claimGenerator'),
              rootStore.demoGenerators.proxy('documentGenerator'),
          )
        : new ApiFileCabinetDataSource(
              'provider',
              Object.values(ProviderDisplayDocumentType),
              createFileCabinetProviderClients(setGroup),
          );
    return new FileCabinetStore({ dataSource });
}
